import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import * as _ from 'underscore';

// Service
import { UserEditService } from '../../service/user-edit/user-edit.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-user-edit',
	templateUrl: './user-edit.component.html',
	providers: [
		UserEditService,
		HttpModule
	]
})
export class UserEditComponent implements OnInit {

	guid: string;
	private sub: any;

	private token;
	public userDetails: any[] = [];
	public otherGroups: any[] = [];
	public userDetailsGroup: any[] = [];
	public userDetailsCommercialStructure: any[] = [];
	public userDetailsRepresentative: any[] = [];
	public userOtherGroup: any[] = [];
	public userGroupFilter: any[] = [];
	public processes: any[] = [];
	public users: any[] = [];
	public processeUser: any[] = [];
	public processeStructure: any[] = [];
	public vacationStart;
	public vacationEnd;
	public vacations: any[] = [];
	public commercialstructurepaper: any[] = [];
	public representative: any[] = [];
	public commercialstructure: any[] = [];
	public permissoes: any[] = [];
	public substituto: string = '';
	public subUsers: any[] = null;
	public userSearchValue: string = "";

	private optRepresentante: string;
	private isRepresentante: boolean = false;


	private today = moment();
	
	  //Option to datepicker
	  private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	  };

	constructor(private userEditService: UserEditService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		$("#saveClient").css({
			"display": "none"
		});

		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid']; // (+) converts string 'id' to a number
		});

		this.userEditService.getUserDetails(this.token, this.guid).subscribe(result => {

			this.userDetails = result.Result;
			this.userDetailsGroup = result.Result.Grupos.map((res: Response) => res);
			this.userDetailsCommercialStructure = result.Result.EstruturasComerciais.map((res: Response) => res);
			this.userDetailsRepresentative = result.Result.Representantes.map((res: Response) => res);

			if (result.Success == true) {
				this.getUserGroups();

				this.userEditService.getRepresentative(this.token).subscribe(result => {
					this.representative = result.Result;
				}, error => {
					console.log(error);
				});

				this.setStructure(this.optRepresentante, true);

				/*
				this.userEditService.getCommercialStructurePaper(this.token).subscribe(result => {
					this.commercialstructurepaper = result.Result;

					if (this.userDetailsCommercialStructure[0]) {
						for (var i = this.commercialstructurepaper.length - 1; i >= 0; i--) {
							if (this.commercialstructurepaper[i].ID == this.userDetailsCommercialStructure[0].EstruturaComercialPapelID) {
								this.commercialstructurepaper[i].checked = true;
							}
						}
					}

					if (this.userDetailsCommercialStructure[0]) {
						this.setStructure(this.userDetailsCommercialStructure[0].EstruturaComercialPapelID, true);
					} else {
						this.setStructure(this.optRepresentante, true);
					}
				});


				this.userEditService.getRepresentative(this.token).subscribe(result => {
					this.representative = result.Result;
				}, error => {
					console.log(error);
				});
				*/

			}
		}, error => {
			console.log(error);

		});

		this.optRepresentante = 'R';
		//this.getProcessesByUserID();
		// this.getUsers();
		this.getVacations();
	}

	userDetailsNome: string = "";
	userTipoAcesso: number = 1;
	userDetailsLogin: string = "";
	userDetailsEmail: string = "";
	userDetailsEmpresa: string = "";
	userDetailsAtivo: boolean = true;
	otherGroupID: string = "";

	getUserGroups() {
		this.userEditService.getOtherGroups(this.token).subscribe(result => {
			this.userOtherGroup = result.Result;

			for (var i = this.userOtherGroup.length - 1; i >= 0; i--) {
				for (var j = this.userDetailsGroup.length - 1; j >= 0; j--) {
					if (this.userOtherGroup[i].ID == this.userDetailsGroup[j].ID) {
						this.userOtherGroup[i].checked = true;
					}
				}
			}
		}, error => {
			console.log(error);

		});
	}

	editUser(userDetailsNome, userTipoAcesso, userDetailsLogin, userDetailsEmail, userDetailsAtivo, userDetailsEmpresaID) {

		if ($("#optADCreateUser").is(":checked")) {
			this.userTipoAcesso = 1;
		}
		if ($("#optSFCreateUser").is(":checked")) {
			this.userTipoAcesso = 2;
		}

		if ($("#statusCreateUser").is(":checked")) {
			this.userDetailsAtivo = true;
		} else {
			this.userDetailsAtivo = false;
		}

		var objUser = {
			ID: this.guid,
			Nome: userDetailsNome,
			TipoAcesso: this.userTipoAcesso,
			Login: userDetailsLogin,
			Email: userDetailsEmail,
			Ativo: this.userDetailsAtivo,
			EmpresasID: userDetailsEmpresaID,
			Grupos: []
		};

		var ListGroups = this.userOtherGroup.filter(opt => opt.checked).map(opt => opt.ID);
		for (let obj of ListGroups) {
			objUser.Grupos.push({ ID: obj.toString(), Ativo: true });
		}

		console.log("Dude, thats me!",objUser);

		this.userEditService.saveUser(this.token, objUser).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Usuário editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/usuarios');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		});
	};

	resetUserStructure() {
		this.commercialstructure.forEach((item) => {item.selected = false});
		this.editUserStructure(false);
	}

	editUserStructure(redirect:Boolean = true) {

		var objStructure = {
			ID: this.guid,
			Grupos: [],
			EstruturasComerciais: [],
			Representantes: []
		}

		var ListGroups = this.userOtherGroup.filter(opt => opt.checked).map(opt => opt.ID);
		for (let obj of ListGroups) {
			objStructure.Grupos.push({ ID: obj.toString(), Ativo: true });
		}

		if (this.isRepresentante) {
			objStructure.Representantes = this.commercialstructure.filter((item) => { return item.selected === true; });
		} else {
			objStructure.EstruturasComerciais = this.commercialstructure.filter((item) => { return item.selected === true; });
		}

		this.userEditService.editUserStructure(this.token, objStructure).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Estrutura salva com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				if (redirect) {
					this.router.navigateByUrl('/usuarios');
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		});

	}

	getProcessesByUserID() {
		this.userEditService.getProcessesByUserID(this.token, this.guid).subscribe(result => {
			if (result.Success) {
				this.processes = result.Result.Grupos;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	// getUsers() {
	// 	this.userEditService.getUsers(this.token).subscribe(result => {
	// 		if (result.Success) {
	// 			this.users = result.Result;
	// 		} else {
	// 			this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
	// 		}
	// 	}, error => {
	// 		console.log(error);
  //
	// 	});
	// }

	searchUser() {
		this.userEditService.searchUsers(this.userSearchValue, this.token).subscribe(result => {
				if (result.Success) {
					this.subUsers = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
	}

	setStructure(id, isEdit) {
		this.getUserGroups();
		this.isRepresentante = false;
		console.log('ID', id);
		this.isRepresentante = true;
		this.userEditService.getRepresentative(this.token).subscribe(result => {
			if (result.Success) {
				this.commercialstructure = result.Result;
				if (isEdit) {
					for (var i = this.commercialstructure.length - 1; i >= 0; i--) {
						for (var j = this.userDetailsRepresentative.length - 1; j >= 0; j--) {
							if (this.commercialstructure[i].CodigoSap == this.userDetailsRepresentative[j].CodigoSap) {
								this.commercialstructure[i].selected = true;
							}
						}
					}
				}

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	setStructureSub(selectElement) {
		console.log("selectElement: ", selectElement)
		for (var i = 0; i < selectElement.options.length; i++) {
			var optionElement = selectElement.options[i];
			var optionModel = this.commercialstructure[i];
			if (optionElement.selected == true) { optionModel.selected = true; }
			else { optionModel.selected = false; }
		}
	}

	setProcesse(checked, id) {
		if (!checked) {
			$("select[name='" + id + "'").prop('selectedIndex', 0);
			this.processeUser = this.processeUser.filter(item => item.GrupoID !== id);
		}
	}

	setUserSub(processe, user) {
		this.processeUser.push({ UsuarioID: user.value, GrupoID: processe });
	}

	resetVacation() {
		console.log('Reset');
		this.vacationStart = null;
		this.vacationEnd = null;
		this.substituto = "";
	}

	saveVacation() {

		let alreadyInterval;
		let dateBigger;

		const tempMomentInicio = moment(this.vacationStart.jsdate);
		const tempMomentFim = moment(this.vacationEnd.jsdate);

		this.vacations.forEach(vacation => {
			const tempFeriasInicio = moment(vacation.FeriasInicio);
			const tempFeriasFim = moment(vacation.FeriasFim);

			if (tempMomentInicio.isBetween(tempFeriasInicio,tempFeriasFim)){
				alreadyInterval = true;
			}
			if (tempMomentFim.isBetween(tempFeriasInicio,tempFeriasFim)){
				alreadyInterval = true;
			}
			if (tempMomentInicio < tempFeriasInicio && tempMomentFim > tempFeriasFim){
				alreadyInterval = true;
			}
			if (tempMomentInicio.format("YYYY-MM-DD") == tempFeriasInicio.format("YYYY-MM-DD") || 
				tempMomentFim.format("YYYY-MM-DD") == tempFeriasFim.format("YYYY-MM-DD") ||  
				tempMomentFim.format("YYYY-MM-DD")  == tempFeriasInicio.format("YYYY-MM-DD") || 
				tempMomentInicio.format("YYYY-MM-DD") == tempFeriasFim.format("YYYY-MM-DD")){
				alreadyInterval = true;
			}
		});

		if (moment(this.vacationStart.jsdate) > moment(this.vacationEnd.jsdate) || alreadyInterval){

			if (moment(this.vacationStart.jsdate) > moment(this.vacationEnd.jsdate)){
				this.flashMessagesService.show("Atenção: Data inicial maior que data final.", { cssClass: 'alert-danger', timeout: 6000 });
			}
			if (alreadyInterval){
				this.flashMessagesService.show("Atenção: Período já cadastrado, verifique as datas.", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}else{
			var data = {
				UsuarioID: this.guid,
				FeriasInicio: tempMomentInicio.format("YYYY-MM-DD HH:mm:ss"),
				FeriasFim: tempMomentFim.format("YYYY-MM-DD HH:mm:ss"),
				SubstitutoID: this.substituto
			}

			this.userEditService.insertVacation(this.token, data).subscribe(result => {
				if (result.Success) {
					this.flashMessagesService.show("Substituição de responsável realizada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
					this.subUsers = [];
					this.userSearchValue = '';
					this.resetVacation();
					this.getVacations();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			});

		}

	}

	getVacations() {
		this.userEditService.getVacations(this.token, this.guid).subscribe(result => {
			if (result.Success) {
				this.vacations = result.Result.filter(item => item.Ativo);
				console.log(result.Result);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	removeVacation(id) {
		this.userEditService.removeVacation(this.token, id).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Período de férias removido com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				this.getVacations();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/usuarios');
	}

}



// WEBPACK FOOTER //
// ./src/app/user/component/user-edit/user-edit.component.ts